<template>

  <div>
    <LoadingIndicator v-if=" !microNote" />
    <div v-else-if=" !microNote.micro_note_images || microNote.micro_note_images.length <= 0">
      <div role="alert" class="alert alert-danger">
        <span class="icon mdi mdi-close-circle-o"></span> Failed to load micro note image
      </div>
    </div>


    <div v-else>
      <!-- <p>
    newKeyword: {{newKeyword}}<br> -->
      <!-- <p>dragCoords: {{dragCoords}}</p> -->
      <!-- <p>activeKeywordId="{{activeKeywordId}}" ({{typeof activeKeywordId}})</p> -->
      <!-- <p>microNoteId: {{microNote.id}}</p> -->
      <!-- <p>newKeywords: {{newKeywords}}</p> -->
      <!-- <p>Scale: {{scale}}</p> -->
      <!-- <p>imageDisplayWidth: {{imageDisplayWidth}}</p> -->


      <div class="image-container" :class="{creating: dragCoords}">
        
        <ImageKeyword v-if="newKeyword" :scale="scale" :keyword="newKeyword" />
        <ImageKeyword :activeKeywordId="activeKeywordId"
                      :onDelete="handleDeleteKeyword"
                      :onUpdate="handleUpdateKeyword"
                      :onClick="handleKeywordClick"
                      v-for="keyword in newKeywordsArray"
                      :scale="scale"
                      :keyword="keyword" />

        <img ref="image"
             @mousedown.prevent="createKeywordStart"
             @mousedown.prevent.stop.self="handleImageClick"
             :src="microNote.micro_note_images[0].image_url" />
      </div>

      <p class="text-muted xs-mt-20">{{statusMessage}}</p>
    </div>




  </div>

</template>


<script>
import Vue from 'vue'
import _ from 'underscore'
import {cloneDeep} from 'lodash'
import Chapter from '../../resources/chapter'
import MicroNote from '../../resources/microNote'
// import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import moment from 'moment'
import ImageKeyword from './ImageKeyword'


const nextKeywordId = (keywords) => {
  // console.log(keywords);
  const ids = _.map(keywords, keyword => parseInt(keyword.id));
  // console.log(ids);
  if( !_.isArray(ids) || !ids.length) return 0;
  return _.max(ids) + 1;
}

export default {
  props: ['microNote'],

  components: {
    ImageKeyword,
  },

  created() {
    this.newKeywords = cloneDeep(this.microNote.keywords);

    // Watch window size change to calc scale
    $(window).on('resize.microNoteImageEditor', _.debounce(() => {
      this.imageDisplayWidth = $('.image-container img').width();
    }, 200));
  },

  mounted() {
    this.imageDisplayWidth = $('.image-container img').width();
  },

  beforeDestroy() {
    this.clearListeners();
  },

  methods: {
    // Done whenever the micro note id changes
    reset() {
      console.log('reset!')
      this.newKeywords = cloneDeep(this.microNote.keywords);
      this.activeKeywordId = null;
      this.dragCoords = null;
      this.status = null;
      this.imageDisplayWidth = $('.image-container img').width();
    },

    handleDeleteKeyword(keyword) {
      Vue.delete(this.newKeywords, keyword.id);
    },

    handleUpdateKeyword(keywordId, changes) {
      // console.log('handleUpdateKeyword: '+keywordId)
      // console.log(changes)
      const newKeyword = Object.assign({}, this.newKeywords[keywordId], changes);
      Vue.set(this.newKeywords, keywordId, newKeyword);
    },

    handleImageClick() {
      // deselect keywords
      this.activeKeywordId = null;
      $('.keyword input').blur();
    },

    handleKeywordClick(keyword) {
      this.activeKeywordId = keyword.id;
    },

    validKeyword(keyword) {
      if( !keyword) return false;
      let valid = true;

      // Required properties
      const requiredProps = ['x', 'y', 'width', 'height'];
      _.each(requiredProps, (prop) => {
        if( !_.has(keyword, prop)) valid = false;
        if(_.isNaN(keyword[prop])) valid = false;
      })
      if( !valid) return false;

      // Check mins
      if(keyword.width < this.minKeywordWidth) return false;
      if(keyword.height < this.minKeywordHeight) return false;

      return true;
    },

    addKeyword(keyword) {
      if( !this.validKeyword(keyword)) return false;
      delete keyword.isNew;

      const newId = nextKeywordId(this.newKeywordsArray);
      Vue.set(this.newKeywords, newId, keyword);
      this.activeKeywordId = newId;
    },

    createKeywordStart(e) {
      const offset = $(e.target).offset();
      this.dragCoords = {
        // Absolute window location
        absoluteStartX: e.pageX,
        absoluteStartY: e.pageY,
        // relative to the image
        relativeStartX: e.pageX - offset.left,
        relativeStartY: e.pageY - offset.top,
      };

      $(window).on('mousemove.microNoteImageEditor', this.createKeywordMouseMove);
      $(window).on('mouseup.microNoteImageEditor', this.createKeywordEnd);
    },

    createKeywordMouseMove(e) {
      if( !this.dragCoords) return;
      const offset = $(this.$refs.image).offset();
      const imageWidth = $(this.$refs.image).width();
      const imageHeight = $(this.$refs.image).height();

      // X
      let relativeEndX = e.pageX - offset.left;
      let absoluteEndX = e.pageX;
      if(e.pageX < offset.left) {
        // too far left
        relativeEndX = 0;
        absoluteEndX = offset.left;
      } else if(e.pageX > offset.left + imageWidth) {
        // too far right
        relativeEndX = imageWidth;
        absoluteEndX = imageWidth + offset.left;
      }

      // Y
      let relativeEndY = e.pageY - offset.top;
      let absoluteEndY = e.pageY;
      if(e.pageY < offset.top) {
        // too far up
        relativeEndY = 0;
        absoluteEndY = offset.top;
      } else if(e.pageY > offset.top + imageHeight) {
        // too far down
        relativeEndY = imageHeight;
        absoluteEndY = imageHeight + offset.top;
      }

      Vue.set(this.dragCoords, 'relativeEndX', relativeEndX);
      Vue.set(this.dragCoords, 'absoluteEndX', absoluteEndX);
      Vue.set(this.dragCoords, 'relativeEndY', relativeEndY);
      Vue.set(this.dragCoords, 'absoluteEndY', absoluteEndY);
    },

    createKeywordEnd(e) {
      this.addKeyword(Object.assign({}, this.newKeyword));
      this.dragCoords = null;
      this.clearListeners();
    },

    clearListeners() {
      $(window).off('mousemove.microNoteImageEditor');
      $(window).off('mouseup.microNoteImageEditor');
      $(window).off('resize.microNoteImageEditor');
    },

    saveChanges: _.debounce(function(keywords) {
      //console.log(this.newKeywords);
      this.status = 'saving';
      const changes = Object.assign({}, {keywords: this.newKeywords});
      this.$store.dispatch('updateMicroNote', {
        id: this.microNote.id,
        changes,
        callback: (err) => {
          if(err) {
            Toast.error('Failed to save changes')
            this.status = 'error';
          } else {
            this.status = 'saved';
          }
        },
      });
    }, 500),

  },


  computed: {
    statusMessage() {
      if( !this.microNote) return '';
      if(this.status === 'saving') {
        return 'Saving...';
      } else if(this.status === 'saved') {
        return 'Changed saved.';
      } else if(this.status === 'error') {
        return 'Failed to save changes';
      } else {
        return `Last saved ${moment(this.microNote.updated_at).fromNow()}`;
      }
    },


    // Calculate image size / actual image size
    scale() {
      if( !this.microNote || !this.imageDisplayWidth || !this.microNote.micro_note_images || !this.microNote.micro_note_images[0].image_width) return 1;
      return this.imageDisplayWidth / this.microNote.micro_note_images[0].image_width;
    },

    newKeyword() {
      if( !this.dragCoords) return null;

      const {
        absoluteStartX, absoluteStartY, absoluteEndX, absoluteEndY,
        relativeStartX, relativeStartY, relativeEndX, relativeEndY,
      } = this.dragCoords;

      let newKeyword = {
        value: '',
        isNew: true,
      }

      const absXDist = Math.abs(absoluteStartX - absoluteEndX);
      const absYDist = Math.abs(absoluteStartY - absoluteEndY);
      newKeyword = {
        width:    absXDist,
        height:   absYDist,
        x:        relativeStartX,
        y:        relativeStartY,
        value: '',
        isNew: true,
      }

      // Handle movement up or left
      if(relativeEndX < relativeStartX) newKeyword.x -= absXDist;
      if(relativeEndY < relativeStartY) newKeyword.y -= absYDist;

      // Scale the values back to 'normal'
      _.each(['x', 'y', 'width', 'height'], (prop) => {
        newKeyword[prop] = newKeyword[prop] / this.scale;
      })
      // if( !this.validKeyword(newKeyword)) return null;
      return newKeyword;
    },

    newKeywordsArray() {
      if( !this.newKeywords) return [];

      const keywords = [];
      _.map(_.pairs(this.newKeywords), (pair) => {
        const [id, keyword] = pair;
        keyword.id = id;
        keywords.push(keyword);
      });
      return keywords;
    },

  },


  data() {
    return {
      newKeywords: null, // db map - we will mutate this, which will trigger an update on the server

      // ID of the active keyword (there can only be 1)
      // when a keyword is active additional actions are visible, ie. delete
      activeKeywordId: null,

      dragCoords: null, // records the current drag session
      minKeywordWidth: 10,
      minKeywordHeight: 10,


      // saving status
      status: null,

      // allows us to watch window change to calc scale
      imageDisplayWidth: null,
    }
  },


  watch: {
    microNote(oldValue, newValue) {
      const oldId = oldValue ? oldValue.id : null;
      const newId = newValue ? newValue.id : null;
      if(oldId !== newId) {
        this.reset();

      }
    },

    newKeywords: {
      deep: true,
      handler(newVal, oldVal) {
        if( !oldVal) return; // skip initial load
        this.saveChanges();
      },
    },
  },

}
</script>


<!-- Scoped styling -->
<style lang="scss" scoped>

.image-container {
  position: relative;
  // border: 5px solid red;
  border: 3px solid #d4d4d4;
  border: 1px solid #404040;
  display: inline-block;
  max-width: 100%;
  min-width: 700px;

  &.creating {
    // border-color: green;
    .keyword {
      pointer-events: none;
    }
  }

  img {
    width: 100%;
    cursor: crosshair;

    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -o-user-select: none;
    user-select: none;
  }
}


/**
 * Styling for <keyword> as shown in editor (scoped doesn't work for sum reazon)
 */
keyword {
  background: #fcd45e;
  padding: 5px;
  border-radius: 4px;
}

</style>



// WEBPACK FOOTER //
// MicroNoteImageEditor.vue?d0f6e5a4